import { DqTag } from "./dqTag";
import { type DqTagCommandExecutor, type IDqTag } from "./models";
import { maybeActivateDebugSdk } from "./debug/activate";

declare global {
  interface Window {
    dqtag: {
      cmd: DqTagCommandExecutor[];
      instance?: IDqTag;
    };
  }
}

(function () {
  // Honor localStorage / URL-param activation even before `.initialize()`
  // has been called (commands can be queued via window.dqtag.cmd).
  maybeActivateDebugSdk();

  if (window.dqtag?.instance) {
    return;
  }
  const dqTag = new DqTag();
  window.dqtag = window.dqtag ?? {};
  window.dqtag.instance = dqTag;
  dqTag.flushCommandQueue();
})();
